export default __webpack_public_path__ + "i18n/translation-te.d4a259ca.json";